<template>
  <div class="user-tab-overview">
    <v-card class="mb-7">
      <v-data-table
        :headers="tableColumnHeaders"
        :items="dataInvitations"
        :options.sync="options"
        :server-items-length="totalInvitations"
        :loading="loading"
        :no-data-text="$t('eventPage.noGuestForThisEvent')"
        :footer-props="{
          'items-per-page-options': [10, 20]
        }"
        class="row-pointer"
        @click:row="handleClick"
      >
        <template #[`item.last_name`]="{item}">
          <div class="d-flex align-center">
            <v-avatar
              size="33"
              class="me-3"
              tile
            >
              <v-img
                :src="item.guest.image || TSS_IMAGE_PLACEHOLDER"
                @error="item.guest.image = TSS_IMAGE_PLACEHOLDER"
              ></v-img>
            </v-avatar>
            <div class="text-no-wrap">
              <p class="font-weight-medium text--primary mb-n1">
                {{ item.guest.first_name }} {{ item.guest.last_name }}
              </p>

              <span class="text-xs text--disabled">
                <v-icon
                  small
                >
                  {{ resolveGuestGender(item.guest.gender) }}
                </v-icon>
                {{ item.guest.resident_country_name }}</span>
            </div>
          </div>
        </template>
        <template #[`item.instagram`]="{item}">
          <div
            class="link-instagram"
            @click.stop="goToInstagram(item.guest.insta_user_name)"
          >
            @{{ item.guest.insta_user_name }}
          </div>
        </template>
        <template #[`item.followers_count`]>
          todo
          <!--          {{ formatFollowersCount(10500) }}-->
        </template>
        <template #[`item.engagement`]>
          todo
        </template>
        <template #[`item.checks`]="{item}">
          {{ resolveCheckInOut(item.check_in_at) || '-' }} / {{ resolveCheckInOut(item.check_out_at) || '-' }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mdiGenderFemale, mdiGenderMale, mdiInstagram } from '@mdi/js';
import { formatOptions } from '@/services/datatables/datatables.service';
import { ref, watch } from '@vue/composition-api';
import { getInstagramLink } from '@/services/global/global.service';
import { EVENT_PAGE_INVITATION } from '@/router/constants';
import { useRouter } from '@core/utils';
import { TSS_IMAGE_PLACEHOLDER } from '@/constants/global.constants';
import { timeFromISO } from '@secret-society/datetime';
import { fetchInvitations } from '@/services/invitations/invitations.service';

export default {
  name: 'TabOverview',
  props: {
    eventId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { router } = useRouter();

    // State

    const dataInvitations = ref([]);
    const loading = ref(true);
    const totalInvitations = ref(0);
    const options = ref({
      itemsPerPage: 10,
    });
    const tableColumnHeaders = ref([
      {
        text: 'Name',
        value: 'last_name',
        sortable: false,
      },
      { text: 'Instagram', value: 'instagram', sortable: false },
      { text: 'Followers Count', value: 'followers_count', sortable: false },
      { text: 'Engagement', value: 'engagement', sortable: false },
      { text: 'Check in/out', value: 'checks', sortable: false },
    ]);

    // Methods

    const resolveCheckInOut = (check) => timeFromISO(check);

    const resolveGuestGender = (gender) => (gender === 'female' ? mdiGenderFemale : mdiGenderMale);

    const getDataInvitations = async () => {
      loading.value = true;
      const { page, itemsPerPage, sorting } = formatOptions(options.value);
      const { data, paging } = await fetchInvitations(props.eventId, {
        sort: sorting,
        page,
        size: itemsPerPage,
      });
      dataInvitations.value = data;
      totalInvitations.value = paging.count;
      loading.value = false;
    };

    const goToInstagram = (instaProfile) => {
      window.open(getInstagramLink(instaProfile), '_blank');
    };

    const handleClick = (row) => {
      router.push({ name: EVENT_PAGE_INVITATION, params: { eventId: props.eventId, invitationId: row.id } });
    };

    const formatFollowersCount = (count) => {
      const formatter = Intl.NumberFormat('en',
        {
          notation: 'compact',
          minimumFractionDigits: 1,
        });

      return formatter.format(count);
    };

    // Watchers

    const optionsWatch = watch(options, () => {
      getDataInvitations();
    });

    // Return

    return {
      // State

      dataInvitations,
      loading,
      options,
      tableColumnHeaders,
      totalInvitations,

      // Methods

      resolveCheckInOut,
      resolveGuestGender,
      goToInstagram,
      handleClick,
      formatFollowersCount,

      // Watchers
      optionsWatch,

      // Others
      icons: {
        mdiInstagram,
      },
      TSS_IMAGE_PLACEHOLDER,

    };
  },
};

</script>

<style scoped lang='scss'>
::v-deep .row-pointer {
  tbody {
    tr {
      cursor: pointer;
    }
  }
}

.link-instagram {
  &:hover {
    color:white;
  }
}
</style>
